export const enum MenuItem {
    WaMessages = 'WaMessages',
    WaMessagesSetups = 'WaMessagesSetups',
    PhoneVerifications = 'PhoneVerifications',
    FailedPhoneVerifications = 'FailedPhoneVerifications',
    WaTemplatesSetups = 'WaTemplatesSetups'
}

export const Filters = {
    MOR: 'MOR',
    merchantId: 'merchantId',
    merchantName: 'merchantName',
    phone: 'phone',
    status: 'status',
    transactionStatuses: 'transactionStatuses',
    phoneFrequency: 'phoneFrequency',
    isEnabled: 'isEnabled',
    coreId: 'coreId'
};
